import { Ref } from "vue";

interface ConfigItem {
  default(): unknown;
  ref: Ref<boolean>;
}

export function useFormFieldCleaner<FORM extends Record<string, unknown>>(
  config: Partial<Record<keyof FORM, ConfigItem>>,
  form: FORM | Ref<FORM>,
) {
  for (const [key, configItem] of Object.entries(config) as [
    keyof FORM,
    ConfigItem,
  ][]) {
    watch(
      configItem.ref,
      (value) => {
        if (!value) {
          delete unref(form)[key];
        } else {
          unref(form)[key] = configItem.default() as any;
        }
      },
      { immediate: true },
    );
  }
}
